// Je l'ai majoritairement généré avec https://app.quicktype.io/
// C'est quand même bon mais certain modèles pourrons sortir d'ici.

import { CurrencyCode, InSaleStatus, ProductType, SeatsAvailability } from "../../../types/models/basesalemodels";
import { MediaInfo } from "../../../types/models/mediainfo";
import { MembershipPresaleInfo } from "../../../types/models/membershippresaleinfo";
import { PackageShortInfo } from "../../../types/models/packageshortinfo";
import { PromoInfoShort } from "./promoinfoshort";
import { Section } from "../buyticket";
import { TimeZone } from "../../../types/models/timezone";


export interface EventDateInfo {
    EventDateID:                          number;
    ProductType:                          ProductType;
    ProductName:                          string;
    ProductNameFr:                        string;
    ProductNameEn:                        string;
    ProducerName:                         string;
    ProductID:                            string;
    Description:                          string;
    Category:                             string;
    CategoryFr:                           string;
    CategoryEn:                           string;
    DisplayName:                          string | null;
    Date:                                 Date;
    SalesStartDate:                       Date;
    SalesEndDate:                         Date;
    VenueName:                            string;
    IsInSale:                             boolean;
    IsNewDate:                            boolean;
    IsSoldOut:                            boolean;
    IsMandatory:                          boolean;
    InSaleStatus:                         InSaleStatus;
    HasVenuePlan:                         boolean;
    LimitQtySales:                        number;
    SuggestedQtySales:                    number;
    InternetTicketQTYMultipleOf:          number;
    EventNotInSaleCustomMessage:          string;
    ErrorSellingThisEvent:                boolean;
    ErrorSellingThisEventMessage:         string;
    MediaInfo:                            MediaInfo;
    PromoInfo:                            PromoInfoShort;
    MembershipPresaleInfo:                MembershipPresaleInfo | null;
    MembershipPresaleInfos:               MembershipPresaleInfo[];
    ProductInfo:                          any | null;
    SeatsAvailability:                    SeatsAvailability;
    ImportantInfo:                        string;
    CurrencyCode:                         CurrencyCode;
    DateToBeDeterminated:                 boolean;
    EnableAdditionalDateNotificationList: boolean;
    EventHasNoSpecificDate:               boolean;
    HasSameNames:                         boolean;
    SeePromoLink:                         string;
    EventDateCode:                        string;
    HasScheduleRangeSettings:             boolean;
    Packages:                             PackageShortInfo[];
    Sections:                             Section[] | null;
    ForceSectionInPromo:                  boolean;
    TimeZone:                             TimeZone;
    MembershipTypeSaleInfo:               any | null;
    Use2024UnrestrictedSale:              boolean;
    ShowAvailablePlacesOnInternet:        boolean;
    ShowBestTicketFirstOnInternet:        boolean;
    AlwaysAskForPriceOnTicketSelection:   boolean;
    IsGeneralAdmission:                   boolean;
}


export type EventDateDisplayMode = "combo" | "button";




